import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AuthService from 'core/utils/auth/auth-service';
import { startFileDownload } from 'components/ui/FileDownload/reducer';

const propTypes = {
  test: PropTypes.object.isRequired,
};

class TestNextSteps extends React.Component {
  generateConsumerReport = (e) => {
    if (e) { e.preventDefault(); }
    const { startFileDownload, test: { id } } = this.props;

    startFileDownload({
      actionPath: `${process.env.REACT_APP_PUBLIC_API_URL}/consumer_reports`,
      method: 'POST',
      queryParams: {
        token: AuthService.getToken(),
        id,
      },
    });
  }

  renderConsumerReportLink = () => {
    return (
      <a
        className="TestNextStep__item"
        onClick={(e) => this.generateConsumerReport(e)}
      >
        <div className="TestNextStep__item__icon">
          <FontAwesomeIcon icon={["far", "download"]} />
        </div>
        <div className="TestNextStep__item__text">
          <div className="title">Consumer Report</div>
        </div>
      </a>
    );
  }

  render() {
    return (
      <div className="TestNextSteps">
        <h3 className="TestNextSteps__title">Next Steps</h3>
        <Row>
          <Col
            xs={12}
            md={4}
          >
            {this.renderConsumerReportLink()}
          </Col>
          <Col
            xs={12}
            md={4}
          >
            <Link
              className="TestNextStep__item"
              to="/tests/new"
            >
              <div className="TestNextStep__item__icon">
                <FontAwesomeIcon icon={["far", "plus"]} />
              </div>
              <div className="TestNextStep__item__text">
                <div className="title">Add Another Test</div>
              </div>
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
          >
            <Link
              className="TestNextStep__item"
              to="/tests"
            >
              <div className="TestNextStep__item__icon">
                <FontAwesomeIcon icon={["far", "backward"]} />
              </div>
              <div className="TestNextStep__item__text">
                <div className="title">Return to Tests</div>
              </div>
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startFileDownload,
  }, dispatch);
};

TestNextSteps.propTypes = propTypes;

export default connect(undefined, mapDispatchToProps)(TestNextSteps);



// WEBPACK FOOTER //
// ./src/features/test/TestNextSteps.js